import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { baseBindState, getPrimarySegment } from './lib/helpers';

export const uwUmbrellaReview = defineInternalTask({
  taskName: internalTasks.UWUmbrellaReview,
  config: {
    staffDisplayName: 'Has umbrella: review needed',
    // Per the PR spec this fires for Home/Condo only — not Auto. Restricting it here
    // also prevents bundle policies from creating a duplicate task on the auto side.
    policyTypes: ['H', 'C'],
    reviewTeam: reviewTeams.uwOps,
    enabled: true,
    trigger: ({ policy }) => {
      const segment = getPrimarySegment(policy);
      // `includeUmbrella` lives directly on the segment, not under `.global` —
      // see dynamo-be/lambdas/bind-requests-to-accounts/src/index.js:3024 and
      // dynamo-be/lambdas/bind-requests-to-accounts/src/repositories/segment.repository.js:102.
      if (!segment?.includeUmbrella) {
        return null;
      }
      return { data: {}, bindState: baseBindState(policy) };
    },
    description: () => 'This policy was bound with Umbrella attached, which requires manual UW review.'
  }
});
